import "../styles/TipoC.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
  FaArrowLeft,
  FaArrowRight,
  FaBath,
  FaBed,
  FaCalendarDays,
  FaCar,
  FaCheck,
  FaCouch,
  FaDoorOpen,
  FaKitchenSet,
  FaRulerCombined,
  FaShirt,
  FaSun,
} from "react-icons/fa6";

import imagenTipoC1 from "../assets/proyecto5.jpg";
import imagenTipoC2 from "../assets/proyecto6.jpg";
import imagenProyecto from "../assets/proyecto1.jpg";

const whatsappLink =
  "https://wa.me/18299623399?text=Hola%2C%20me%20interesa%20recibir%20más%20información%20sobre%20el%20Apartamento%20Tipo%20C%20de%20Residencial%20YANNA%20I.";

const estadisticas = [
  {
    icono: <FaRulerCombined />,
    numero: "86.47",
    unidad: "m²",
    texto: "Área de construcción",
  },
  {
    icono: <FaBed />,
    numero: "2",
    unidad: "",
    texto: "Habitaciones",
  },
  {
    icono: <FaBath />,
    numero: "2.5",
    unidad: "",
    texto: "Baños",
  },
  {
    icono: <FaCar />,
    numero: "1",
    unidad: "",
    texto: "Parqueo",
  },
];

const especificaciones = [
  {
    icono: <FaBed />,
    titulo: "Dos habitaciones",
    descripcion:
      "Habitaciones cómodas y privadas, diseñadas para proporcionar un descanso agradable.",
  },
  {
    icono: <FaBath />,
    titulo: "Dos baños y medio",
    descripcion:
      "Una distribución práctica que ofrece comodidad para residentes y visitantes.",
  },
  {
    icono: <FaDoorOpen />,
    titulo: "Walk-in closet",
    descripcion:
      "Espacio de almacenamiento funcional para mantener todo correctamente organizado.",
  },
  {
    icono: <FaCouch />,
    titulo: "Sala y comedor",
    descripcion:
      "Un área social conectada, iluminada y perfecta para compartir en familia.",
  },
  {
    icono: <FaKitchenSet />,
    titulo: "Cocina funcional",
    descripcion:
      "Diseñada para aprovechar cada espacio y facilitar las actividades diarias.",
  },
  {
    icono: <FaSun />,
    titulo: "Balcón privado",
    descripcion:
      "Un ambiente abierto que aporta iluminación, ventilación y conexión con el exterior.",
  },
  {
    icono: <FaShirt />,
    titulo: "Área de lavado",
    descripcion:
      "Zona independiente para realizar las tareas del hogar con mayor comodidad.",
  },
  {
    icono: <FaCar />,
    titulo: "Un parqueo",
    descripcion:
      "Espacio destinado para el estacionamiento seguro de un vehículo.",
  },
];

const aparecer = {
  oculto: {
    opacity: 0,
    y: 55,
  },

  visible: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.85,
      ease: "easeOut",
    },
  },
};

function TipoC() {
  return (
    <main className="tipoC">
      {/* HERO */}

      <section className="tipoCHero">
        <div className="tipoCHeroDecoration tipoCHeroDecorationOne"></div>
        <div className="tipoCHeroDecoration tipoCHeroDecorationTwo"></div>

        <div className="tipoCHeroContainer">
          <motion.div
            className="tipoCHeroContent"
            initial={{
              opacity: 0,
              x: -80,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.95,
              ease: "easeOut",
            }}
          >
            <Link to="/" className="tipoCVolver">
              <FaArrowLeft />
              Volver
            </Link>

            <div className="tipoCLabel">
              <span></span>
              RESIDENCIAL YANNA I
            </div>

            <h1>
              Apartamento
              <strong>Tipo C</strong>
            </h1>

            <p className="tipoCHeroDescription">
              Una opción moderna, funcional y accesible para quienes
              desean adquirir su nuevo hogar en una ubicación
              residencial de San Cristóbal.
            </p>

            <p className="tipoCHeroDescriptionSecondary">
              Sus 86.47 m² han sido distribuidos para ofrecer
              comodidad, iluminación natural y espacios adecuados
              para la vida diaria.
            </p>

            <div className="tipoCPriceBox">
              <div>
                <span>PRECIO DE VENTA</span>
                <strong>US$130,000</strong>
              </div>

              <div className="tipoCPriceLine"></div>

              <div>
                <span>MONTO DE RESERVA</span>
                <strong>US$5,000</strong>
              </div>
            </div>

            <div className="tipoCHeroButtons">
              <Link
                to="/reserva"
                className="tipoCButton tipoCButtonPrimary"
              >
                Reservar apartamento
                <FaArrowRight />
              </Link>

              <Link
                to="/reserva"
                className="tipoCButton tipoCButtonSecondary"
              >
                <FaCalendarDays />
                Agendar una visita
              </Link>
            </div>
          </motion.div>

          <motion.div
            className="tipoCHeroVisual"
            initial={{
              opacity: 0,
              x: 80,
              scale: 0.94,
            }}
            animate={{
              opacity: 1,
              x: 0,
              scale: 1,
            }}
            transition={{
              duration: 1,
              delay: 0.15,
              ease: "easeOut",
            }}
          >
            <div className="tipoCImageLabel">
              <span>APARTAMENTO TIPO C</span>
              <strong>86.47 m²</strong>
            </div>

            <img
              src={imagenTipoC1}
              alt="Apartamento Tipo C de Residencial YANNA I"
            />

            <div className="tipoCVisualFooter">
              <div>
                <span>Precio</span>
                <strong>US$130,000</strong>
              </div>

              <div className="tipoCAvailable">
                <span></span>
                Disponible
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ESTADÍSTICAS */}

      <section className="tipoCStats">
        <div className="tipoCStatsContainer">
          {estadisticas.map((item, index) => (
            <motion.article
              key={item.texto}
              className="tipoCStatCard"
              initial={{
                opacity: 0,
                y: 40,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
                amount: 0.2,
              }}
              transition={{
                duration: 0.55,
                delay: index * 0.1,
              }}
              whileHover={{
                y: -8,
              }}
            >
              <div className="tipoCStatIcon">
                {item.icono}
              </div>

              <div className="tipoCStatNumber">
                <strong>{item.numero}</strong>

                {item.unidad && (
                  <span>{item.unidad}</span>
                )}
              </div>

              <p>{item.texto}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* GALERÍA */}

      <section className="tipoCGallery">
        <motion.div
          className="tipoCGalleryHeader"
          variants={aparecer}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span>CONOCE EL APARTAMENTO</span>

          <h2>
            Dos vistas del mismo Apartamento Tipo C.
          </h2>

          <p>
            Observa su distribución, sus espacios y la manera en que
            cada área ha sido organizada para aprovechar los 86.47 m².
          </p>
        </motion.div>

        <div className="tipoCGalleryGrid">
          <motion.figure
            className="tipoCGalleryCard"
            initial={{
              opacity: 0,
              x: -60,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
            transition={{
              duration: 0.85,
            }}
          >
            <img
              src={imagenTipoC1}
              alt="Primera vista del Apartamento Tipo C"
            />

            <figcaption>
              <span>VISTA 01</span>
              <strong>
                Distribución del Apartamento Tipo C
              </strong>
            </figcaption>
          </motion.figure>

          <motion.figure
            className="tipoCGalleryCard"
            initial={{
              opacity: 0,
              x: 60,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
            transition={{
              duration: 0.85,
              delay: 0.1,
            }}
          >
            <img
              src={imagenTipoC2}
              alt="Segunda vista del Apartamento Tipo C"
            />

            <figcaption>
              <span>VISTA 02</span>
              <strong>
                Espacios del Apartamento Tipo C
              </strong>
            </figcaption>
          </motion.figure>
        </div>
      </section>

      {/* EXPERIENCIA */}

      <section className="tipoCExperience">
        <div className="tipoCExperienceContainer">
          <motion.div
            className="tipoCExperienceImage"
            initial={{
              opacity: 0,
              x: -70,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
            transition={{
              duration: 0.9,
            }}
          >
            <img
              src={imagenTipoC2}
              alt="Apartamento Tipo C"
            />

            <div className="tipoCImageFrame"></div>

            <div className="tipoCImageMessage">
              <span>DISEÑO FUNCIONAL</span>

              <strong>
                Un hogar cómodo, moderno y pensado para ti.
              </strong>
            </div>
          </motion.div>

          <motion.div
            className="tipoCExperienceContent"
            variants={aparecer}
            initial="oculto"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >
            <span className="tipoCSectionLabel">
              COMODIDAD Y FUNCIONALIDAD
            </span>

            <h2>
              Una distribución inteligente para la vida diaria.
            </h2>

            <p>
              El Apartamento Tipo C combina espacios sociales
              conectados con habitaciones privadas y cómodas. La sala,
              el comedor y la cocina forman un ambiente práctico para
              compartir y disfrutar.
            </p>

            <p>
              Su balcón proporciona iluminación y ventilación natural,
              mientras que el walk-in closet y el área de lavado
              complementan una vivienda diseñada para facilitar la
              rutina diaria.
            </p>

            <div className="tipoCExperienceChecks">
              <div>
                <FaCheck />
                <span>Distribución funcional</span>
              </div>

              <div>
                <FaCheck />
                <span>Iluminación natural</span>
              </div>

              <div>
                <FaCheck />
                <span>Ambientes conectados</span>
              </div>

              <div>
                <FaCheck />
                <span>Precio accesible</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ESPECIFICACIONES */}

      <section className="tipoCSpecifications">
        <motion.div
          className="tipoCSectionHeader"
          variants={aparecer}
          initial="oculto"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >
          <span>CARACTERÍSTICAS</span>

          <h2>
            Todo lo necesario para disfrutar tu nuevo hogar.
          </h2>

          <p>
            Espacios organizados para ofrecer comodidad, privacidad
            y funcionalidad en cada ambiente.
          </p>
        </motion.div>

        <div className="tipoCSpecificationsGrid">
          {especificaciones.map((item, index) => (
            <motion.article
              key={item.titulo}
              className="tipoCSpecificationCard"
              initial={{
                opacity: 0,
                y: 35,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                duration: 0.55,
                delay: index * 0.07,
              }}
              whileHover={{
                y: -7,
              }}
            >
              <div className="tipoCSpecificationIcon">
                {item.icono}
              </div>

              <h3>{item.titulo}</h3>

              <p>{item.descripcion}</p>
            </motion.article>
          ))}
        </div>
      </section>

      {/* INFORMACIÓN DEL PROYECTO */}

      <section className="tipoCProject">
        <div className="tipoCProjectImage">
          <img
            src={imagenProyecto}
            alt="Residencial YANNA I"
          />
        </div>

        <motion.div
          className="tipoCProjectContent"
          initial={{
            opacity: 0,
            x: 65,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          viewport={{
            once: true,
            amount: 0.2,
          }}
          transition={{
            duration: 0.9,
          }}
        >
          <span>RESIDENCIAL YANNA I</span>

          <h2>
            Una oportunidad para vivir e invertir.
          </h2>

          <p>
            Residencial YANNA I se encuentra en Madre Vieja, San
            Cristóbal, dentro de un entorno residencial tranquilo y
            conectado con diferentes servicios de la ciudad.
          </p>

          <p>
            El proyecto integra ascensor, parqueo techado, lobby
            climatizado, portón eléctrico, gas común y sistemas de
            seguridad en las áreas compartidas.
          </p>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="tipoCProjectLink"
          >
            Solicitar más información
            <FaArrowRight />
          </a>
        </motion.div>
      </section>

      {/* RESERVA FINAL */}

      <motion.section
        className="tipoCFinalCta"
        initial={{
          opacity: 0,
        }}
        whileInView={{
          opacity: 1,
        }}
        viewport={{
          once: true,
          amount: 0.25,
        }}
        transition={{
          duration: 1,
        }}
      >
        <div className="tipoCFinalOverlay"></div>

        <div className="tipoCFinalContent">
          <span>APARTAMENTO TIPO C</span>

          <h2>
            Tu nuevo hogar por
            <strong> US$130,000</strong>
          </h2>

          <p>
            Reserva con US$5,000 y agenda una visita para conocer
            personalmente esta opción de Residencial YANNA I.
          </p>

          <div className="tipoCFinalButtons">
            <Link
              to="/reserva"
              className="tipoCFinalPrimary"
            >
              Agendar mi visita
              <FaArrowRight />
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tipoCFinalSecondary"
            >
              Hablar con un asesor
            </a>
          </div>
        </div>
      </motion.section>
    </main>
  );
}

export default TipoC;